var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H2.24444C1.80885 15 1.59105 15 1.42467 14.9152C1.27833 14.8407 1.15934 14.7217 1.08477 14.5753C1 14.4089 1 14.1912 1 13.7556V1M15 4.11111L10.7733 8.3378C10.6193 8.49181 10.5423 8.56881 10.4535 8.59766C10.3754 8.62304 10.2913 8.62304 10.2132 8.59766C10.1244 8.56881 10.0474 8.49181 9.89336 8.3378L8.43998 6.88442C8.28597 6.73042 8.20897 6.65341 8.12017 6.62456C8.04207 6.59918 7.95793 6.59918 7.87983 6.62456C7.79103 6.65341 7.71403 6.73042 7.56002 6.88442L4.11111 10.3333M15 4.11111H11.8889M15 4.11111V7.22222",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeIcon);
export default __webpack_public_path__ + "static/media/trade-icon.abd7a6adc651ffdfca1592c87bdf0773.svg";
export { ForwardRef as ReactComponent };